import { render, staticRenderFns } from "./VitalDefaultDetail.vue?vue&type=template&id=e84d0d0e&lang=pug"
import script from "./VitalDefaultDetail.vue?vue&type=script&lang=js"
export * from "./VitalDefaultDetail.vue?vue&type=script&lang=js"
import style0 from "./VitalDefaultDetail.vue?vue&type=style&index=0&id=e84d0d0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports